"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Radio = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FormFieldWrapper = _interopRequireDefault(require("../FormFieldWrapper/FormFieldWrapper"));

var _FieldLabel = _interopRequireDefault(require("../../ui/FieldLabel"));

var _radioConfig = require("./radioConfig");

var _types = require("../../types");

var _validation = require("../../types/validation");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var InheritedFieldValidation = _flowRuntime["default"].tdz(function () {
  return _validation.InheritedFieldValidation;
});

var InputStyle = _flowRuntime["default"].tdz(function () {
  return _types.InputStyle;
});

var RadioDefinition = _flowRuntime["default"].tdz(function () {
  return _radioConfig.RadioDefinition;
});

var Node = _flowRuntime["default"].tdz(function () {
  return _react.Node;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("radio", _flowRuntime["default"].ref(RadioDefinition)), _flowRuntime["default"].property("disabled", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("inheritedFieldValidation", _flowRuntime["default"].array(_flowRuntime["default"].ref(InheritedFieldValidation)), true), _flowRuntime["default"].property("onChange", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].any()), _flowRuntime["default"]["return"](_flowRuntime["default"].any())), true), _flowRuntime["default"].property("noOptionalLabel", _flowRuntime["default"]["boolean"](), true)));

var RadioProps = _flowRuntime["default"].type("RadioProps", _flowRuntime["default"].object(_flowRuntime["default"].property("disabled", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("input", _flowRuntime["default"].object()), _flowRuntime["default"].property("inputStyle", _flowRuntime["default"].ref(InputStyle)), _flowRuntime["default"].property("isRequired", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("radio", _flowRuntime["default"].ref(RadioDefinition))));

var Radio = function Radio(_arg) {
  var disabled = _arg.disabled,
      input = _arg.input,
      inputStyle = _arg.inputStyle,
      isRequired = _arg.isRequired,
      radio = _arg.radio;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FieldLabel["default"], {
    field: radio,
    isRequired: isRequired
  }), radio.items && radio.items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("label", {
      key: item.key,
      htmlFor: "".concat(input.name, ".").concat(item.key),
      className: item.classes || inputStyle.controlClass
    }, /*#__PURE__*/_react["default"].createElement("input", Object.assign({}, input, {
      checked: input.value.toString() === item.value,
      disabled: disabled,
      id: "".concat(input.name, ".").concat(item.key),
      type: "radio",
      value: item.value || item.key,
      className: inputStyle.indicatorClass
    })), /*#__PURE__*/_react["default"].createElement("span", null, item.label || item.value || item.key));
  }));
};

exports.Radio = Radio;
Radio.defaultProps = {
  disabled: false
};

var RFRadio = function RFRadio(_arg2) {
  var disabled = _arg2.disabled,
      onChange = _arg2.onChange,
      radio = _arg2.radio,
      inheritedFieldValidation = _arg2.inheritedFieldValidation,
      noOptionalLabel = _arg2.noOptionalLabel;
  return /*#__PURE__*/_react["default"].createElement(_FormFieldWrapper["default"], {
    field: radio,
    renderField: function renderField(_ref) {
      var input = _ref.input,
          inputStyle = _ref.inputStyle,
          isRequired = _ref.isRequired;
      return /*#__PURE__*/_react["default"].createElement(Radio, {
        disabled: disabled,
        input: input,
        inputStyle: inputStyle,
        isRequired: noOptionalLabel ? true : isRequired,
        radio: radio
      });
    },
    inheritedFieldValidation: inheritedFieldValidation,
    onChange: onChange,
    noOptionalLabel: noOptionalLabel
  });
};

RFRadio.defaultProps = {
  disabled: false,
  inheritedFieldValidation: [],
  onChange: undefined,
  noOptionalLabel: false
};
var _default = RFRadio;
exports["default"] = _default;